import React from 'react';
import { useSelector } from 'react-redux';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

// This component will render when the loading state is true
const LoadingScreen = () => {
  const loading = useSelector((state) => state.user.loading); // Adjust this path according to your Redux state structure

  // Render only when loading is true
  if (!loading) return null;

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(255, 255, 255, 0.8)', // Light overlay
        zIndex: 1300, // Ensure it appears above other content
      }}
    >
      <CircularProgress size={60} thickness={4} />
    </Box>
  );
};

export default LoadingScreen;